export const Logo = ({ size = 34, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    data-testid="fantasybet-logo"
  >
    <rect x="2" y="2" width="44" height="44" rx="12" fill="#0F172A" />
    <path
      d="M15 33V15h14v4.2H20v4h7.5v4.2H20v5.6H15Z"
      fill="#FAFAFC"
    />
    <circle cx="33" cy="30" r="4" fill="#0055FF" />
  </svg>
);
